import { ISourceInfo } from '@/config/interfaces';

export default {
  namespaced: true,

  state: {
    // 当前数据源。enum: MYSQL, HIVE, ORACLE, MONGODB, REDIS, REDIS
    currentSource: null,
    // 数据源信息是一个对象，内部属性可以查看 ISourceInfo
    sourceInfo: new ISourceInfo(),
    navigates: []
  },

  getters: {
    // 获取数据源 id
    connToken: state => (state.sourceInfo && state.sourceInfo.connToken ? state.sourceInfo.connToken : null),
    currentDbType: state => state.currentSource
  },

  mutations: {
    /**
     * 存储当前数据源。该数据源的值仅在前端作为标识
     */
    STORE_CURRENT_SOURCE(state, source) {
      state.currentSource = source;
    },
    /**
     * 记录当前数据源对应的导航栏路由
     */
    STORE_NAVIGATORS(state, navigators) {
      state.navigates = navigators;
    },
    /**
     * 记录当前数据源的信息
     */
    STORE_SOURCE_INFO(state, sourceInfo) {
      state.sourceInfo = sourceInfo;
    }
  },

  actions: {
    async storeCurrentSource({ commit }, source) {
      commit('STORE_CURRENT_SOURCE', source);
    },
    async storeNavigators({ commit }, navigators) {
      commit('STORE_NAVIGATORS', navigators);
    },
    async storeSourceInfo({ commit }, sourceInfo) {
      commit('STORE_SOURCE_INFO', sourceInfo);
    }
  }
};
